import { getAvailabilityOptions } from '@/helpers/filterOptions';
import { useCompanyNeedStore } from '@/modules/companyNeed/store/companyNeedStore';
import { Availabilities } from '@/types/filters';

import type { PeriodPreference } from '@/modules/companyNeed/types/periodPreference';
import type { LabelValue } from '@/types/common';

interface AvailabilitySource {
	periodPreferences: PeriodPreference[];
	weekEndRequired: boolean;
}

export const getAvailabilityOptionsFromCompanyNeed = (
	source?: AvailabilitySource
): LabelValue<string>[] => {
	const data = source ?? useCompanyNeedStore().companyNeed;
	if (!data) return [];

	const periodPreferenceValues = (data.periodPreferences ?? []) as string[];
	return getAvailabilityOptions().filter(
		(option) =>
			periodPreferenceValues.includes(option.value) ||
			(data.weekEndRequired && option.value === Availabilities.WEEKEND)
	);
};
